import clienteAxios from "../config/axios";

export async function getAccountingProrationByTDoc(tDocID) {
    return clienteAxios.get(`/accountingProrationByTDoc/${tDocID}`);
}

export async function updateListAccountingProrationByTDoc(tDoc, prorrateoList) {
    return clienteAxios.put('/accountingProration/updateListByTDoc', { tDoc, prorrateoList });
}
